module.exports = __webpack_public_path__ + "static/media/lalashan2.4196fae2.webp";